module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_0-4dd37a3ac2059b41d2273a1159dc9270.png";